<template>
  <div>
    <Loading></Loading>
    <!-- banner -->
    <div class="banner" :style="cover">
      <div class="bgShade">
        <v-avatar>
          <img :src="getUrl + $store.state.app.userInfo.avatar" alt="John" />
        </v-avatar>
        <h1 class="banner-title">
          私人测试
        </h1>
      </div>
    </div>
    <v-card style="padding: 20px;">
      <v-responsive :aspect-ratio="16 / 9">
        <v-btn class="ma-2" color="secondary" @click="addSql">
          添加事件
        </v-btn>
        <v-btn class="ma-2" @click="addTag">
          配置标签
        </v-btn>
        <v-btn class="ma-2" color="secondary" @click="WebRTCTo">
          语音聊天室
        </v-btn>
        <wang-calendars ref="WangCalendars"></wang-calendars>
      </v-responsive>
    </v-card>
    <PopWindow ref="PopWindow" @updateEvent="updateEvent"></PopWindow>
    <editTag ref="editTag"></editTag>
  </div>
</template>

<script>
import Loading from "@/components/loading/loading";
import PopWindow from "./modules/index.vue";
import WangCalendars from "./modules/WangCalendars.vue";
import editTag from "./modules/editTag.vue";
export default {
  components: {
    Loading,
    PopWindow,
    WangCalendars,
    editTag
  },
  created() {},
  destroyed() {},
  metaInfo: {},
  data: function() {
    return {
      getUrl: process.env.VUE_APP_IMG_API
    };
  },
  methods: {
    addSql() {
      this.$refs.PopWindow.dialog = true;
    },
    addTag() {
      this.$refs.editTag.dialog = true;
    },
    updateEvent() {
      this.$refs.WangCalendars.updateRange();
    },
    WebRTCTo() {
      this.$router.push("/WebRTC");
    }
  },
  computed: {
    cover() {
      var cover = "";
      this.$store.state.blogInfo.pageList.forEach(item => {
        if (item.pageLabel === "about") {
          cover = item.pageCover;
        }
      });
      return "background: url(" + cover + ") center center / cover no-repeat";
    }
  }
};
</script>

<style scoped>
/*  调整首图背景不透明度  by 程序儒  2023年4月11日  */
.bgShade {
  background-color: rgba(0, 0, 0, 0.15);
  display: flex;
  justify-content: center;
}
.about-content {
  word-break: break-word;
  line-height: 1.8;
  font-size: 18px;
  text-align: center;
}

.my-wrapper {
  text-align: center;
}

.author-avatar {
  transition: all 0.5s;
}

.author-avatar:hover {
  transform: rotate(360deg);
}
.urlavatar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
